// extracted by mini-css-extract-plugin
export default {"item":"SideListItem_item__aICcl","info":"SideListItem_info__igPKx"};